import { Routes, Route } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import Landing from "./pages/Landing";
import Dashboard from "./pages/Dashboard";
import VaultManagement from "./pages/VaultManagement";
import AcceptInvitation from "./pages/AcceptInvitation";
import TreeView from "./pages/TreeView";
import PersonView from "./pages/PersonView";
import MediaLibrary from "./pages/MediaLibrary";
import GlobalMediaLibrary from "./pages/GlobalMediaLibrary";
import MediaTextEditor from "./pages/MediaTextEditor";
import ConnectedPersons from "./pages/ConnectedPersons";
import ConnectedPersonDetail from "./pages/ConnectedPersonDetail";
import Locations from "./pages/Locations";
import LocationDetail from "./pages/LocationDetail";
import Memories from "./pages/Memories";
import MemoryDetail from "./pages/MemoryDetail";
import NationalArchives from "./pages/NationalArchives";
import NationalArchivesRecord from "./pages/NationalArchivesRecord";
import NotFound from "./pages/NotFound";
import ProtectedRoute from "./components/Auth/ProtectedRoute";
import LoadingSpinner from "./components/Common/LoadingSpinner";

function App() {
  const { isLoading } = useAuth0();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/invite/:token" element={<AcceptInvitation />} />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/vault-management"
        element={
          <ProtectedRoute>
            <VaultManagement />
          </ProtectedRoute>
        }
      />
      <Route
        path="/trees/:treeId"
        element={
          <ProtectedRoute>
            <TreeView />
          </ProtectedRoute>
        }
      />
      <Route
        path="/trees/:treeId/persons/:personId"
        element={
          <ProtectedRoute>
            <PersonView />
          </ProtectedRoute>
        }
      />
      <Route
        path="/trees/:treeId/media"
        element={
          <ProtectedRoute>
            <MediaLibrary />
          </ProtectedRoute>
        }
      />
      <Route
        path="/media"
        element={
          <ProtectedRoute>
            <GlobalMediaLibrary />
          </ProtectedRoute>
        }
      />
      <Route
        path="/media/:mediaId/edit-text"
        element={
          <ProtectedRoute>
            <MediaTextEditor />
          </ProtectedRoute>
        }
      />
      <Route
        path="/connected-persons"
        element={
          <ProtectedRoute>
            <ConnectedPersons />
          </ProtectedRoute>
        }
      />
      <Route
        path="/connected-persons/:personId"
        element={
          <ProtectedRoute>
            <ConnectedPersonDetail />
          </ProtectedRoute>
        }
      />
      <Route
        path="/locations"
        element={
          <ProtectedRoute>
            <Locations />
          </ProtectedRoute>
        }
      />
      <Route
        path="/locations/:locationId"
        element={
          <ProtectedRoute>
            <LocationDetail />
          </ProtectedRoute>
        }
      />
      <Route
        path="/memories"
        element={
          <ProtectedRoute>
            <Memories />
          </ProtectedRoute>
        }
      />
      <Route
        path="/memories/:memoryId"
        element={
          <ProtectedRoute>
            <MemoryDetail />
          </ProtectedRoute>
        }
      />
      <Route
        path="/national-archives"
        element={
          <ProtectedRoute>
            <NationalArchives />
          </ProtectedRoute>
        }
      />
      <Route
        path="/national-archives/record/:recordId"
        element={
          <ProtectedRoute>
            <NationalArchivesRecord />
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default App;